/* eslint-disable max-len */
import React, { useState, useEffect } from 'react'

function AlertToggleCell({ initialValue, disabled, id, onToggle }) {
    const [checked, setChecked] = useState(initialValue || false)

    useEffect(() => {
        setChecked(initialValue || false)
    }, [initialValue])

    const handleChange = async () => {
        const newValue = !checked
        setChecked(newValue)
        try {
            const success = await onToggle(newValue)
            if (!success) {
                setChecked(!newValue)
            }
        } catch {
            setChecked(!newValue)
        }
    }

    return (
        <td className="px-[20px] py-2 text-sm text-start font-normal text-[#031624]">
            <div className="status custom-toggle flex items-center">
                <label className="switch" style={{marginLeft: '10px'}}>
                    <input
                        type="checkbox"
                        onChange={handleChange}
                        checked={checked}
                        disabled={disabled}
                    />
                    <span id={id} className="slider round"></span>
                </label>
            </div>
        </td>
    )
}

export default React.memo(AlertToggleCell)
